import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import CartImage from '../../../image/cart-iframe.svg';

export default function CartIcon(props) {
  const productItemsService = props.ProductItemsService;

  const cart = useSelector((state) => state.cart);
  const order = useSelector((state) => state.order);
  const [cartItemsCount, setCartItemsCount] = useState(0);

  useEffect(() => {
    setCartItemsCount(productItemsService.getCartItemsCount(cart.cart, order));
  }, [cart, order]);

  return (
      <a
        id='cart-iframe'
        onClick={props.goToCart}
      >
        <img
          alt='Brand'
          id='cart-logo'
          src={CartImage}
        />
        <div className='cart-counter'>{cartItemsCount}</div>
      </a>
  );
}
